<script>
import { NOTIFICATION_STATUS } from '@utils/constant'
import reduce from 'lodash/reduce'
import mapValues from 'lodash/mapValues'
export default {
  props: {
    hasLeftButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payload: {
        search_agent: '',
        status: '',
        page_no: 1,
        start: '',
        end: '',
        title: '',
        created_name: '',
        schedule_start: '',
        schedule_end: '',
      },
      show: false,
      componentDateKey: 999,
      componentScheduleKey: 0,
    }
  },
  computed: {
    statusOptions() {
      const status = reduce(
        NOTIFICATION_STATUS,
        (result, value, key) => {
          result.push({ value: key, label: value })
          return result
        },
        []
      )
      return [{ value: '', label: '' }, ...status]
    },
  },
  created() {
    const filter = this.$route.query
    if (filter.page_no) {
      for (const key in this.payload) {
        this.payload[key] = filter[key]
      }
    }
  },
  methods: {
    setDate(value) {
      this.payload.start = value.date_start
      this.payload.end = value.date_end
    },
    setScheduleDate(value) {
      this.payload.schedule_start = value.date_start
      this.payload.schedule_end = value.date_end
    },
    search(reset = false) {
      this.$emit('submit:search', this.payload, reset)
      this.show = !this.show
    },
    cancel() {
      this.payload = mapValues(this.payload, () => '')
      this.componentDateKey++
      this.componentScheduleKey++
      this.payload.page_no = 1
      this.search(true)
    },
  },
}
</script>

<template>
  <div id="notification-popup-filter">
    <CDropdown
      :show.sync="show"
      placement="bottom-start"
      :add-toggler-classes="
        `btn btn-outline-dark ${hasLeftButton &&
          'border-left-0 rounded-left-0'}`
      "
      add-menu-classes="p-2"
    >
      <template v-slot:toggler-content>
        <font-awesome-icon icon="search" />
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <CForm
          ref="form"
          class="mt-3"
          @submit.stop.prevent="handleSubmit(search)"
        >
          <BaseSelect
            label="ステータス"
            :value.sync="payload.status"
            :options="statusOptions"
          />
          <BaseDateRangerPicker
            :key="componentDateKey"
            picker-type="datetime"
            :start-date.sync="payload.start"
            :end-date.sync="payload.end"
            main-label="実績期間"
            @update:value="(v) => setDate(v)"
          />
          <BaseDateRangerPicker
            :key="componentScheduleKey"
            picker-type="datetime"
            :start-date.sync="payload.schedule_start"
            :end-date.sync="payload.schedule_end"
            main-label="予定期間"
            @update:value="(v) => setScheduleDate(v)"
          />
          <BaseInput v-model="payload.title" label="タイトル" />
          <BaseInput v-model="payload.created_name" label="作成者" />
          <div class="d-flex align-items-center justify-content-between">
            <CButton color="primary" type="submit" class="flex-grow-1">
              検索
            </CButton>
            <CButton color="light" class="flex-grow-1 ml-2" @click="cancel">
              クリア
            </CButton>
          </div>
        </CForm>
      </validation-observer>
    </CDropdown>
  </div>
</template>

<style lang="scss" scoped>
#notification-popup-filter {
  ::v-deep .rounded-left-0 {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  ::v-deep .dropdown-menu {
    width: 300px;
  }
}
</style>
